<template>
    <section>
        <div id="ModalEnvioAssinatura" class="modal fade in" data-backdrop="static" data-keyboard="false" role="dialog">
            <div class="modal-dialog modal-el">
                <div class="modal-content">
                    <div class="modal-header">
                        <p class="modal-title"><i class="fa fa-share"></i> Enviar para assinatura:
                            <strong>{{file.arquivo_nome}}</strong></p>
                        <button type="button" class="close" @click="closeModal()" aria-label="Close">
                            <span aria-hidden="true">×</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col-8">
                                <div class="form-group" :class="{'is-invalid':errors.has('email')}">
                                    <label><i class="fa fa-envelope"></i> E-mail</label>
                                    <small class="float-right">Assinado <i
                                            class="fa fa-check-circle text-green"></i></small>
                                    <small class="float-right">Não Assinado <i class="fa fa-times-circle text-red"></i>
                                        /
                                    </small>
                                    <email-complete id="email" name="email" ref="AutoComplete" @newData="newEmail"
                                        @newGroup="newGroup" @listAll="listAll" @onSelect="selectUser"
                                        :src="'/api/autocomplete-assinatura'"></email-complete>
                                    <div class="invalid-feedback help-block error">{{errors.first('email')}}</div>
                                </div>
                            </div>
                            <div class="col-4">
                                <div class="form-group" :class="{'is-invalid':errors.has('tipo')}">
                                    <label><i class="fa fa-pencil"></i> Tipo de assinatura</label>
                                    <div class="input-group">
                                        <select v-validate="{required:true}" v-model="request.assinatura_tipo"
                                            class="form-control" name="tipo">
                                            <option selected="selected" :value="null">{{$t('words.select')}}</option>
                                            <option value="1">Assinar</option>
                                            <option value="2">Aprovar</option>
                                            <option value="3">Reconhecer</option>
                                            <option value="4">Assinar como parte</option>
                                            <option value="5">Assinar como testemunha</option>
                                            <option value="6">Assinar como interveniente</option>
                                            <option value="7">Acusar recebimento</option>
                                            <option value="8">Dar ciência</option>
                                        </select>
                                        <span class="input-group-btn">
                                            <button @click="addExistentUser()" class="btn btn-success btn-flat"><i
                                                    class="fa fa-plus"></i></button>
                                        </span>
                                    </div>
                                    <div class="invalid-feedback help-block error">{{errors.first('tipo')}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="form-group">
                                <p-check @change="handleFileOrder()" :color="appLayout.check"
                                    v-model="file.habilitar_ordem" class="p-switch p-fill">Habilitar
                                    envio das assinaturas na ordem definida</p-check> <popover :title="'Ordem definida'" :content="'Marcando essa opção, os signatários deverão assinar na ordem que for configurada.'"></popover>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <table class="table table-sm table-condensed">
                                    <thead>
                                        <tr>
                                            <th class="col-md-1">#</th>
                                            <th v-if="file.habilitar_ordem">Ordem</th>
                                            <th>Nome</th>
                                            <th>E-mail</th>
                                            <th>Tipo de Assinatura</th>
                                            <th class="text-right">Enviar E-mail</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(assinatura, i) in file.assinaturas" :key="i">
                                            <td><button :disabled="assinatura.loading || assinatura.assinado_em"
                                                    @click="removeMail(i)" href="#"
                                                    class="btn btn-sm btn-default text-red"><i
                                                        class="fa fa-trash"></i></button>
                                            </td>
                                            <td v-if="file.habilitar_ordem">
                                                <select v-model="assinatura.ordem" :disabled="assinatura.assinado_em"
                                                    @change="updateOrderSignature(assinatura, i)"
                                                    class="form-control-sm">
                                                    <option v-for="(ord, o) in file.assinaturas.length" :key="o+i"
                                                        :value="o+1">
                                                        {{o+1}}</option>
                                                </select>
                                            </td>
                                            <td><i v-if="assinatura.assinado" class="fa fa-check-circle text-green"></i>
                                                <i v-else class="fa fa-times-circle text-red"></i>
                                                {{assinatura.assinatura_nome}}</td>
                                            <td>{{assinatura.assinatura_email}}</td>
                                            <td>{{getTipoAssinatura(assinatura.assinatura_tipo, assinatura.assinado)}}
                                            </td>
                                            <td><button
                                                    :disabled="assinatura.assinado_em || assinatura.loading || loadingSingle"
                                                    @click="sendEmail(assinatura)"
                                                    class="float-right btn-sm btn btn-default">
                                                    <i class="fa"
                                                        :class="{'fa-mail-forward': !assinatura.loading, 'fa-circle-o-notch fa-spin': assinatura.loading}"></i>
                                                </button></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer justify-content-between">
                        <button type="button" class="float-left btn btn-default" @click="closeModal()"><i
                                class="fa fa-times"></i> {{$t('words.cancel')}}</button>
                        <button type="button" :disabled="loading || !zeroAssinaturas || loadingSingle"
                            @click="sendEmails()" class="btn btn-success"><i class="fa fa-send-o"></i>
                            {{$t('words.send')}} todos <i v-show="loading"
                                class="fa fa-circle-o-notch fa-spin"></i></button>
                    </div>
                </div>
            </div>
        </div>
        <m-add-user v-if="display" ref="mAddUser" :signatarios="file.assinaturas"></m-add-user>
        <m-group-signatarios v-if="display" ref="mGroup" @insert="insertGroup"></m-group-signatarios>
        <m-list-signatarios v-if="display" ref="mListSignatario" @addSignatarios="insertGroup"></m-list-signatarios>
    </section>
</template>

<script>
    import EmailComplete from '../AutoCompleteEmail';
    import mAddUser from '../file-signature/components/m-new-signatario.vue';
    import MListSignatarios from '../file-signature/components/m-list-signatarios.vue';
    import MGroupSignatarios from '../file-signature/components/m-group-signatarios.vue';
    export default {
        components: {
            EmailComplete,
            mAddUser,
            MListSignatarios,
            MGroupSignatarios
        },
        data() {
            return {
                display: false,
                loading: false,
                loadingSingle: false,
                file: {},
                selectedUser: {
                    assinatura_nome: '',
                    assinatura_email: '',
                    ordem: 1
                },
                request: {
                    assinatura_tipo: null,
                    file: null,
                    assinado: false,
                    loading: false,
                    assinaturas: []
                }
            }
        },
        computed: {
            zeroAssinaturas() {
                return this.file.assinaturas && this.file.assinaturas.findIndex(x => x.assinado != true) > -1;
            },
        },
        methods: {
            closeModal() {
                Object.assign(this.$data, this.$options.data());
                this.$validator.reset();
                this.display = false;
                $('#ModalEnvioAssinatura').modal('toggle');
            },
            listAll() {
                this.$refs.mListSignatario.show();
            },
            newGroup() {
                this.$refs.mGroup.fetchData();
                $('#ModalGrupoSignatario').modal('toggle');
            },
            handleFileOrder() {
                this.loading = true;
                this.$store.dispatch('handleFileOrder', this.file.id).then(response => {
                    toastr({
                        icon: response.status,
                        title: response.message
                    });
                }).catch(error => {
                    toastr({
                        icon: error.status,
                        title: error.message
                    });
                }).finally(fn => {
                    this.loading = false;
                });
            },
            updateOrderSignature(signature, i) {
                signature.file = this.file.id;
                this.loading = true;
                this.$store.dispatch('updateOrderSignature', signature).then(response => {
                    if (response.status == 201) {
                        this.file.assinaturas[i] = response.data.signature;
                    }
                    toastr({
                        icon: response.data.status,
                        title: response.data.message
                    });
                }).catch(error => {
                    toastr({
                        icon: error.status,
                        title: error.message
                    });
                }).finally(fn => {
                    this.loading = false;
                });
            },
            sendEmails() {
                this.request.assinaturas = [];
                this.file.assinaturas.map(x => {
                    if (!x.assinado) {
                        this.request.assinaturas.push(x);
                    }
                });
                if (this.request.assinaturas.length > 0) {
                    this.loading = true;
                    this.request.file = this.file.id;
                    this.$store.dispatch('requestSignatures', this.request).then(response => {
                        toastr({
                            icon: 'success',
                            title: 'E-mails enviados!'
                        });
                        this.updateFile(response);
                        this.display = false;
                        this.$store.commit('REFRESH_USER_FILES', Math.random().toString(36).substr(2, 5));
                        $('#ModalEnvioAssinatura').modal('toggle');
                    }).catch(error => {
                        toastr({
                            icon: error.status,
                            title: error.message
                        });
                    }).finally(fn => {
                        this.loading = false;
                    });
                } else {
                    toastr({
                        title: 'Insira ao menos um e-mail!',
                        icon: 'warning'
                    });
                    this.focusAutocomplete();
                }
            },
            sendEmail(email) {
                let req = {
                    file: this.file.id,
                    assinaturas: [
                        email
                    ]
                }
                email.loading = true;
                this.loadingSingle = true;
                this.$forceUpdate();
                this.$store.dispatch('sendSignature', req).then(response => {
                    this.updateFile(response);
                    toastr({
                        icon: 'success',
                        title: 'E-mail enviado!'
                    });
                    this.$store.commit('REFRESH_USER_FILES', Math.random().toString(36).substr(2, 5));
                }).catch(error => {
                    toastr({
                        icon: error.status,
                        title: error.message
                    });
                }).finally(fn => {
                    email.loading = false;
                    this.loadingSingle = false;
                    this.$forceUpdate();
                });
            },
            updateFile(response) {
                this.file.assinaturas = response.assinaturas;
                this.file.finished = response.finished;
                this.file.signatures = response.signatures;
            },
            focusAutocomplete() {
                $('#email')[0].children[0].children[1].focus();
            },
            selectUser(payload) {
                this.selectedUser.assinatura_nome = payload.nome;
                this.selectedUser.assinatura_email = payload.email;
                this.selectedUser.assinatura_documento = payload.documento;
                this.selectedUser.assinatura_telefone = payload.telefone;
            },
            newEmail() {
                $('#ModalAddSignatario').modal('toggle');
            },
            validateUser(payload) {
                if (!payload.assinatura_email) {
                    toastr({
                        title: 'Insira um e-mail!',
                        icon: 'warning'
                    });
                    this.errors.add({
                        field: 'email',
                        msg: 'O campo precisa ser informado.'
                    });
                    this.focusAutocomplete();
                    throw 'invalid email';
                }
                if (this.file.assinaturas.findIndex(
                        x => x.assinatura_email == payload.assinatura_email &&
                        x.assinatura_tipo == this.request.assinatura_tipo) > -1) {
                    toastr({
                        title: 'E-mail já adicionado para esse tipo de assinatura!',
                        icon: 'warning'
                    });
                    this.errors.add({
                        field: 'email',
                        msg: 'campo obrigatório!'
                    });
                    this.focusAutocomplete();
                    throw 'E-mail já adicionado';
                }
            },
            addUser(payload) {
                try {
                    this.validateUser(payload);
                    this.errors.remove('email');
                } catch (e) {
                    return;
                }
                this.insertUser(payload);
                $('#ModalAddUser').modal('toggle');
            },
            insertUser(payload) {
                toastr({
                    title: 'E-mail adicionado!',
                    icon: 'success'
                });
                this.file.assinaturas.push(payload);
                this.focusAutocomplete();
            },
            addExistentUser() {
                this.$validator.validateAll().then(valid => {
                    if (valid) {
                        try {
                            this.validateUser(this.selectedUser);
                            this.errors.remove('email');
                        } catch (e) {
                            return;
                        }
                        this.selectedUser.assinatura_tipo = this.request.assinatura_tipo;
                        this.insertUser(this.selectedUser);
                        this.$refs.AutoComplete.reset();
                        this.selectedUser = {
                            assinatura_nome: '',
                            assinatura_email: null,
                        }
                        this.focusAutocomplete();
                    } else {
                        try {
                            this.validateUser(this.selectedUser);
                            this.errors.remove('email');
                        } catch (e) {
                            return;
                        }
                    }
                });
            },
            removeMail(id) {
                let assinatura = this.file.assinaturas[id];
                if (!assinatura.id) {
                    this.file.assinaturas.splice(id, 1);
                    toastr({
                        title: 'E-mail removido',
                        icon: 'success'
                    });
                } else {
                    assinatura.loading = true;
                    this.$store.dispatch('removeSignature', {
                        assinatura: assinatura.id,
                        arquivo: assinatura.fk_arquivo_id
                    }).then(response => {
                        console.log(response);
                        this.updateFile(response);
                        this.file.assinaturas.splice(id, 1);
                        toastr({
                            title: 'E-mail removido',
                            icon: 'success'
                        });
                        this.$store.commit('REFRESH_USER_FILES', Math.random().toString(36).substr(2, 5));
                    }).catch(error => {
                        console.log(error);
                        this.updateFile(error.file);
                        toastr({
                            icon: error.status,
                            title: error.message
                        });
                    }).finally(f => {
                        assinatura.loading = false;
                    });
                }
            },
            insertGroup(payload) {
                payload.grupo.signatarios.map(item => {
                    item.token_tipo = payload.token_tipo;
                    item.assinatura_tipo = payload.assinatura_tipo;
                    if (this.file.assinaturas.findIndex(
                            x => x.assinatura_email == item.assinatura_email &&
                            x.assinatura_tipo == item.assinatura_tipo) == -1) {
                        this.insertUser(item);
                    }
                });
                toastr({
                    title: 'Grupo Adicionado!',
                    icon: 'success'
                });
            }
        }
    }
</script>